import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useThemeContext } from '../../../contexts'
import { namespaces } from '../../../utils/i18n'
import { useCurrentTenantConfig } from '../../../utils/tenants'
import { LoadingTemplate } from './LoadingTemplate'

type Props = {
  children: JSX.Element
}
export const ThemeLoaderLayout: React.FC<Props> = ({ children }) => {
  // Check if theme is loaded
  const { isLoaded: isThemeLoaded } = useThemeContext()

  const currentTenantConfig = useCurrentTenantConfig()
  const isTenantLoaded = !!currentTenantConfig?.tenantId

  const [showSpinner, setShowSpinner] = useState(true)

  // Check if translations from i18n are loaded
  const { i18n } = useTranslation()
  const [areTranslationsLoaded, setAreTranslationsLoaded] = useState(false)

  useEffect(() => {
    i18n.loadNamespaces(namespaces, () => {
      setAreTranslationsLoaded(true)
    })
  }, [i18n])

  useEffect(() => {
    // The timer is set to show for 1 seconds because otherwise
    // it might flicker if the download speed is faster
    const timer = setTimeout(() => {
      setShowSpinner(false)
    }, 1000)

    return () => {
      clearTimeout(timer)
    }
  })

  // If theme, css, logo and translations are not loaded yet show spinner
  // The supplier needs to select a tenant otherwise the spinner
  // would load for ever because it can't load the theme
  if (
    isTenantLoaded &&
    (showSpinner || !isThemeLoaded || !areTranslationsLoaded)
  ) {
    return <LoadingTemplate />
  }

  return <div className="fadein animation-duration-500">{children}</div>
}
